
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAuth } from '../auth/AuthContext';
import './MainLayout.css';

function MainLayout({ children }) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <main className="main-content">{children}</main>
      <Footer />
    </>
  );
}

export default MainLayout;
